import { render } from "./Ebooks.vue?vue&type=template&id=078f0f8e&scoped=true"
import script from "./Ebooks.vue?vue&type=script&lang=js"
export * from "./Ebooks.vue?vue&type=script&lang=js"

import "./Ebooks.vue?vue&type=style&index=0&id=078f0f8e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078f0f8e"]])

export default __exports__